export enum FamilyChangeType {
  NoChangeIsStillInFamily = 'NoChangeIsStillInFamily',
  NoChangeIsStillNotFamily = 'NoChangeIsStillNotFamily',
  BecomesAFamily = 'BecomesAFamily',
  StopsBeingAFamily = 'StopsBeingAFamily',
}
